<template>
    <div>
        รับสินค้าเข้าไทย
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>